import { createContext, useContext, useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useNotifications } from './Notifications';

const AuthenticationContext = createContext(
    {
        signIn:()=>{}, 
        isGoogleSigned:false,
        authCode:'',
        resetIsGoogleSigned:()=>{},
        googleSignInFailResp : '',
        outlookSync:(successCallback)=>{},
        isOutlookSigned:false,
        resetIsOutlookSigned:()=>{},     
    });

export const AuthenticationProvider = ({ children }) => {
    const notificationsContext = useNotifications();
    const [isGoogleSigned, setIsGoogleSigned] = useState(false);
    const [isOutlookSigned, setIsOutlookSigned] = useState(false);
    const [authCode, setAuthCode] = useState('');
    const [googleSignInFailResp, setGoogleSignInFailResp] = useState('');

    //* this is for the new Outlook Auth Code flow
    const redirectUri = encodeURIComponent(`${process.env.REACT_APP_OUTLOOK_RE_URI}`);
    const clientId = `${process.env.REACT_APP_OUTLOOK_ENT_CLIENT_ID}`;
    let successCallBackFunc = (string) => {};

    notificationsContext.outlookAuthCodeChannel.onmessage = (e) => {
        setIsOutlookSigned(true);
        successCallBackFunc(e.data);
    };

    const googleSignInFailed = (response) => {
        if(response.error){ 
            setGoogleSignInFailResp(response.error);
        };
    }
    
    //Google Authentication
    const responseGoogle = (response) => {
        if(!response.code) return;
        setAuthCode(response.code);
        setIsGoogleSigned(true);
    }

    const resetIsGoogleSigned = () => {
        setIsGoogleSigned(false);
    }

    const resetIsOutlookSigned = () => {
        setIsOutlookSigned(false);
    }

    const signIn = useGoogleLogin({
        onSuccess: responseGoogle,
        onError: googleSignInFailed,
        flow: 'auth-code',
        ux_mode: 'popup',
        scope: 'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.settings.readonly'
    });
    
    const outlookSync = (successCallback) => {
        successCallBackFunc = successCallback;
        const outlookAuthUrl = process.env.REACT_APP_OUTLOOK_ENT_LOGIN+`/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&prompt=select_account&scope=https%3A%2F%2Fgraph.microsoft.com%2FUser.Read%20https%3A%2F%2Fgraph.microsoft.com%2FCalendars.ReadWrite%20https%3A%2F%2Fgraph.microsoft.com%2FCalendars.ReadWrite.Shared%20openid%20email%20offline_access`;
        const win : Window | null = window.open(outlookAuthUrl, "_blank", "popup=yes");
        if(win) win.focus();
    }

    return (
        <AuthenticationContext.Provider value={{ signIn, isGoogleSigned, authCode, resetIsGoogleSigned, outlookSync, isOutlookSigned, resetIsOutlookSigned, googleSignInFailResp }}>
            {children}
        </AuthenticationContext.Provider>
    )
}
export const useAuthenticationContext = () => useContext(AuthenticationContext)
